import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format, formatISO } from "date-fns";

const Certification: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={20}>Спициальность по сертификату</Typography>
                <Typography mb={1} ml={30}>Дата выдачи</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
        </Header>
        <Body>
            <Box>
                <TextField 
                    label="Номер удостоверения"
                    variant="outlined"
                    size="small"
                    sx={{ width: "400px", mb: 1 }}
                />
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "192px", ml: 1, mb: 1 }}
                />
            </Box>
            <Box>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px",mb: 1, mr: 1 }}
                />
                <TextField
                    label="Специальность"
                    variant="outlined"
                    size="small"
                    sx={{width: "492px",mb: 1 }}
                />
            </Box>
            <TextField
                label="Город"
                variant="outlined"
                size="small"
                sx={{width: "400px",mb: 1 }}
            />
            <TextField
                label="Учебное заведение"
                variant="outlined"
                size="small"
                sx={{width: "807px",mb: 1 }}
            />
            <TextField
                label="Сертификат действует до даты"
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "250px", mb: 1 }}
            />
        </Body>
      </Box>
    );
  };

export default Certification;
